import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, db } from '../services/firebase';
import LoadingSpinner from '../components/LoadingSpinner';

const ProtectedRoute = ({ children, requiredUserType = null }) => {
  const [user, loading] = useAuthState(auth);
  const [userType, setUserType] = useState(null);
  const [checkingAccess, setCheckingAccess] = useState(true);

  useEffect(() => {
    const checkUserAccess = async () => {
      if (user) {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          setUserType(userDoc.data().userType);
        }
      }
      setCheckingAccess(false);
    };

    checkUserAccess();
  }, [user]);

  if (loading || checkingAccess) {
    return <LoadingSpinner />;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (requiredUserType && userType !== requiredUserType) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default ProtectedRoute;
